<template>
  <li
    class="rounded-sm px-5 py-2 text-left hover:bg-grey-hover"
    :class="disabled ? 'cursor-not-allowed' : 'cursor-pointer'"
  >
    <slot />
  </li>
</template>

<script lang="ts">
interface Props {
  disabled?: boolean;
}
</script>

<script setup lang="ts">
defineProps<Props>();
</script>
